
define('text!modules/core/templates/not-found.hbs',[],function () { return '<h1>404 - Not Found</h1>';});

